import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { QuickBuild } from 'src/app/people/quick-build.service';
import {
  HeadcountComparisonConfig,
  TopValuesComparisonConfig,
  JobsMovesComparisonConfig,
  HistoricalTenureComparisonConfig,
  PrevNextFlowComparisonConfig,
  TenureCohortComparisonConfig,
} from 'src/app/shared/report-visualizations/interfaces/report-config.interfaces';

interface HeadToHeadChartConfigurations {
  'headcount-comparison'?: HeadcountComparisonConfig;
  'top-values-comparison'?: TopValuesComparisonConfig;
  'job-moves-comparison'?: JobsMovesComparisonConfig;
  'historical-tenure-comparison'?: HistoricalTenureComparisonConfig;
  'talent-flow-comparison'?: PrevNextFlowComparisonConfig;
  'tenure-cohort-comparison'?: TenureCohortComparisonConfig;
}

@Component({
  selector: 'app-head-to-head-dashboard',
  templateUrl: './head-to-head-dashboard.component.html',
  styleUrls: ['./head-to-head-dashboard.component.scss'],
  standalone: false,
})
export class HeadToHeadDashboardComponent implements OnChanges {
  @Input() companyBattleQBs: QuickBuild[] = [];
  @Input() dateRangeStrings: [string, string] = ['', ''];
  @Input() reportTarget: string = 'moneyball';
  @Input() chartConfigs: HeadToHeadChartConfigurations = {};

  @Output() configChange = new EventEmitter<{ chartId: string; config: any }>();

  ngOnChanges(changes: SimpleChanges): void {
    // Handle any change detection logic if needed
  }

  onChartConfigChange(chartId: string, config: any) {
    this.configChange.emit({ chartId, config });
  }
}
